import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon';
import { DRAG_HANDLE_ICON, DRAG_HANDLE_PLACEMENT, DRAG_HANDLE_PLACEMENTS } from './constants';

// Design System — DragHandle
// The grip that starts a drag. It only shows and labels the affordance — the drag itself is
// wired by the caller, which passes its drag source through `ref` (react-dnd) and whatever
// `draggable`/event props its mechanism needs. Dragging is pointer-only, so the grip takes no
// tab stop and is hidden from assistive tech; `label` is its hover title. `placement="outside"` parks the grip in the
// margin beside the row, where the card's own hover rule reveals it; `inline` keeps it in
// the row's flow, always visible.
// Styles: ./index.less ships via less/ats_style.less (white-label pipeline).

const DragHandle = ({
    label,
    placement = DRAG_HANDLE_PLACEMENT.INLINE,
    disabled = false,
    className,
    ref,
    ...rest
}) => (
    <span
        ref={ref}
        className={classNames(
            'ds-drag-handle',
            `ds-drag-handle--${DRAG_HANDLE_PLACEMENTS.includes(placement) ? placement : DRAG_HANDLE_PLACEMENT.INLINE}`,
            { 'ds-drag-handle--disabled': disabled },
            className,
        )}
        title={label}
        aria-hidden="true"
        draggable={!disabled}
        {...rest}
    >
        <Icon value={DRAG_HANDLE_ICON} noMargin />
    </span>
);

DragHandle.propTypes = {
    /** Translated hover title, e.g. t('Reorder step') */
    label: PropTypes.string.isRequired,
    /** `outside` parks it in the margin, revealed on the row's hover */
    placement: PropTypes.oneOf(DRAG_HANDLE_PLACEMENTS),
    disabled: PropTypes.bool,
    className: PropTypes.string,
    /** The caller's drag source (react-dnd connector or a plain ref) */
    ref: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
};

export { DRAG_HANDLE_ICON, DRAG_HANDLE_PLACEMENT, DRAG_HANDLE_PLACEMENTS };
export default DragHandle;
